import React from 'react';

import PropTypes from 'prop-types';

import MaintenanceState from '@adsk/acc-maintenance-state';

import ConnectedTopNavigationOptionalUser from './ConnectedTopNavigationOptionalUser';
import NavigationLayout from './NavigationLayout';

const MaintenancePage = React.forwardRef(({ onLogout, endDate }, ref) => {
  return (
    <NavigationLayout
      ref={ref}
      renderSideNavigation={() => null}
      renderTopNavigation={() => (
        <ConnectedTopNavigationOptionalUser onLogout={onLogout} />
      )}
    >
      <MaintenanceState endDate={endDate} />
    </NavigationLayout>
  );
});

MaintenancePage.displayName = 'MaintenancePage';

MaintenancePage.propTypes = {
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** The end date to show the maintenance page for */
  endDate: PropTypes.instanceOf(Date),
};

export default MaintenancePage;
